module.exports = __webpack_public_path__ + "img/14.28a7968c.jpg";